<article class="feed-card-container">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-green-50 dark:bg-green-900/30 dark:pill-green-900/30">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-green-500">
                        <path d="m12.296 3.464 3.02 3.956" />
                        <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z" />
                        <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <path d="m6.18 5.276 3.1 3.899" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <div class="flex min-w-0 flex-row items-center gap-x-4">
                    <h3 class="truncate text-base font-semibold text-primary">{{ activity.briefApplications.length}}
                        Videos Posted!</h3>
                </div>
                <p class="truncate text-sm text-secondary">
                    {{ activity.briefApplications.length }} videos have been posted for this brief.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-end justify-start h-full gap-y-2">
            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>
    </div>

    <div class="w-full overflow-hidden">
        <div class="w-full flex flex-row items-center justify-start gap-x-2 overflow-x-auto scrollbar-transparent">
            @for (application of activity.briefApplications; track application.id) {
            <brief-feed-posted-sub-post [application]="application" [socialChannel]="socialChannel"></brief-feed-posted-sub-post>
            }
        </div>
    </div>

</article>